{"buildRevision":"515cce1a3bc6c39e15cbf88709b2b0af4ec4ac78","buildTimestamp":"2026-09-04T07:46:21.586Z","dirty":true,"version":"5.6.0"}